import { ArrowRight, MessageSquareHeart, UserCheck } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { useI18n } from "@project/lib/use-i18n";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@project/components/ui/dialog";

export type VisitorRegisterChooserDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function VisitorRegisterChooserDialog({
  open,
  onOpenChange,
}: VisitorRegisterChooserDialogProps) {
  const { t } = useI18n();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-gold/20 max-w-3xl gap-0 overflow-hidden p-0 sm:max-w-3xl">
        <div className="from-gold/15 via-gold/5 bg-gradient-to-b to-background px-6 pb-4 pt-8 text-center sm:px-8 sm:pt-9">
          <div className="border-gold/40 bg-gold/10 mx-auto inline-flex w-fit items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-gold">
            <UserCheck className="h-3.5 w-3.5" />
            {t("home.visitorChooser.badge")}
          </div>
          <DialogTitle className="mt-4 font-serif text-2xl font-bold text-foreground sm:text-3xl">
            {t("home.visitorChooser.title")}
          </DialogTitle>
          <DialogDescription className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground">
            {t("home.visitorChooser.description")}
          </DialogDescription>
        </div>

        <div className="grid gap-4 px-6 pb-8 pt-2 sm:grid-cols-2 sm:px-8">

          <Link
            to="/visitor-inquiry"
            onClick={() => onOpenChange(false)}
            className="card-lift border-gold/40 hover:shadow-gold/15 group flex h-full flex-col rounded-2xl border bg-card p-5 text-left shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:border-gold hover:shadow-lg"
          >
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-primary text-primary-foreground shadow-md">
              <UserCheck className="h-5 w-5" />
            </div>
            <h3 className="mt-4 font-serif text-xl font-semibold tracking-tight text-foreground">
              {t("home.visitorChooser.inquiryTitle")}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">
              {t("home.visitorChooser.inquiryDescription")}
            </p>
            <span className="mt-4 inline-flex items-center text-sm font-semibold text-primary">
              {t("home.visitorChooser.inquiryCta")}
              <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
          <Link
            to="/visitor-form"
            onClick={() => onOpenChange(false)}
            className="card-lift border-gold/40 hover:shadow-gold/15 group flex h-full flex-col rounded-2xl border bg-card p-5 text-left shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:border-gold hover:shadow-lg"
          >
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-primary text-primary-foreground shadow-md">
              <MessageSquareHeart className="h-5 w-5" />
            </div>
            <h3 className="mt-4 font-serif text-xl font-semibold tracking-tight text-foreground">
              {t("home.visitorChooser.feedbackTitle")}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">
              {t("home.visitorChooser.feedbackDescription")}
            </p>
            <span className="mt-4 inline-flex items-center text-sm font-semibold text-primary">
              {t("home.visitorChooser.feedbackCta")}
              <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>


        </div>
      </DialogContent>
    </Dialog>
  );
}
